import React from "react";
import Icon from "components/AppIcon";

const MarketHighlights = ({ stocks, economicEvents }) => {
  const safeStocks = Array.isArray(stocks) ? stocks : [];
  const safeEvents = Array.isArray(economicEvents) ? economicEvents : [];

  return (
    <div
      className="rounded-xl border border-border p-4 md:p-5"
      style={{ background: "var(--color-card)" }}
    >
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={15} color="var(--color-primary)" />
        <h3 className="font-heading text-sm font-semibold text-foreground">Market Highlights</h3>
      </div>
      {/* Trending Stocks */}
      <div className="mb-4">
        <p className="font-caption text-xs text-muted-foreground uppercase tracking-widest mb-2">
          Trending
        </p>
        {safeStocks?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-4 gap-2">
            <Icon name="TrendingUp" size={24} color="var(--color-muted-foreground)" />
            <p className="font-caption text-xs text-muted-foreground">No trending stocks available</p>
          </div>
        ) : (
          <div className="space-y-2">
            {safeStocks?.map((s) => (
              <div
                key={s?.ticker}
                className="flex items-center justify-between p-2 rounded-lg hover:bg-primary/5 transition-all duration-200 cursor-pointer"
                style={{ border: "1px solid transparent" }}
              >
                <div className="flex items-center gap-2 min-w-0">
                  <div
                    className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 font-heading text-xs font-bold"
                    style={{ background: "rgba(0,217,255,0.08)", color: "var(--color-primary)" }}
                  >
                    {(s?.ticker || 'N/A')?.slice(0, 2)}
                  </div>
                  <div className="min-w-0">
                    <p className="font-heading text-xs font-semibold text-foreground">{s?.ticker || 'N/A'}</p>
                    <p className="font-caption text-xs text-muted-foreground truncate">{s?.name || 'Unknown'}</p>
                  </div>
                </div>
                <div className="text-right flex-shrink-0 ml-2">
                  <p className="font-heading text-xs font-semibold text-foreground whitespace-nowrap">
                    ${(s?.price || 0)?.toFixed(2)}
                  </p>
                  <div
                    className="flex items-center gap-0.5 justify-end"
                    style={{ color: (s?.change || 0) >= 0 ? "var(--color-success)" : "var(--color-error)" }}
                  >
                    <Icon
                      name={(s?.change || 0) >= 0 ? "ArrowUpRight" : "ArrowDownRight"}
                      size={11}
                      color={(s?.change || 0) >= 0 ? "var(--color-success)" : "var(--color-error)"}
                    />
                    <span className="font-caption text-xs">
                      {(s?.change || 0) >= 0 ? "+" : ""}{(s?.change || 0)?.toFixed(2)}%
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Economic Events */}
      {safeEvents?.length > 0 && (
        <div>
          <p className="font-caption text-xs text-muted-foreground uppercase tracking-widest mb-2">
            Economic Events
          </p>
          <div className="space-y-2">
            {safeEvents?.map((ev) => (
              <div
                key={ev?.id}
                className="flex items-start gap-2 p-2 rounded-lg"
                style={{ background: "var(--color-secondary)" }}
              >
                <div
                  className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{
                    background:
                      ev?.type === "positive" ?"rgba(16,185,129,0.15)"
                        : ev?.type === "negative" ?"rgba(239,68,68,0.15)" :"rgba(0,217,255,0.1)",
                  }}
                >
                  <Icon
                    name={ev?.type === "positive" ? "TrendingUp" : ev?.type === "negative" ? "TrendingDown" : "Info"}
                    size={12}
                    color={
                      ev?.type === "positive" ?"var(--color-success)"
                        : ev?.type === "negative" ?"var(--color-error)" :"var(--color-primary)"
                    }
                  />
                </div>
                <div className="min-w-0">
                  <p className="font-caption text-xs text-foreground leading-tight">{ev?.title}</p>
                  <p className="font-caption text-xs text-muted-foreground mt-0.5">{ev?.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketHighlights;